export default __webpack_public_path__ + "static/images/smart-trading.99f9c0aa.png";